import { ComponentTypes } from '@wix/editor-const';

export const TPA_COMPONENT_TYPES = [
  ComponentTypes.TpaMultiSection,
  ComponentTypes.TpaSection,
  ComponentTypes.TpaWidget,
  ComponentTypes.TpaGluedWidget,
];

export const APP_COMPONENT_TYPES = [
  ...TPA_COMPONENT_TYPES,
  ComponentTypes.CustomElement,
];

export const SYSTEM_CONTAINER_TYPE = 'wixSystemElements.InternalContainer';
